<template>
  <!-- time -->
  <div class="formGroup isRequired mt15 notranslate">
    <label class="label toCapitalize">{{locale.reservation_time}}</label>
    <select class="input" v-model="time" @change="selectTime">
      <option value="" disabled class="notranslate toCapitalize">{{locale.select_time}}</option>
      <option
        v-for="t in timeList"
        :key="t.timeId"
        :value="t.timeId"
        :disabled="t.disabled">
        {{ t.label && t.label[lang].length > 0 ? `${t.label[lang]} - ${t.name}`: t.name }}
      </option>
    </select>
  </div>
  <!-- //time -->
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormTime',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'reserveDate',
    'reserveTime',
    'timeInfo',
    'guestUserInfo'
  ],
  components: {
    Summary,
    SeatMap
  },
  computed: {
    isToday () {
      return moment(this.reserveDate).isSame(moment(), 'day')
    },
    checkoutInfo () {
      const checkout = this.guestUserInfo && this.guestUserInfo.stayBefore
      const isCheckoutDay = checkout && moment(this.reserveDate).isSame(moment(checkout), 'day')
      const checkoutTime = checkout && (moment(checkout).format('HHmm'))
      return isCheckoutDay && {
        isCheckoutDay: isCheckoutDay,
        checkoutTime: checkoutTime
      }
    },
    timeList () {
      const timeNow = this.timeNow
      const isToday = this.isToday
      const possibleUpTo = this.info.possibleUpTo
      const uptoTime = this.info.possibleUpToTime
      const checkoutInfo = this.checkoutInfo
      function disabled (timeBefore, timeNow, notInclude) {
        return notInclude
          ? parseInt(timeNow) >= parseInt(timeBefore) // 일치하는 시간 허용하지 않음
          : parseInt(timeNow) > parseInt(timeBefore) // 일치하는 시간까지 허용
      }
      return this.timeInfo.map(x => {
        let isDisabled = false
        let isCheckoutOver = false
        if (isToday) { // 오늘 예약 가능?
          if (possibleUpTo) { // 시작시간 이후라도 종료n분전 예약 가능?
            isDisabled = disabled(moment(x.to).add(-(uptoTime), 'minute').format('HHmm'), timeNow)
          } else {
            isDisabled = disabled(moment(x.from).format('HHmm'), timeNow)
          }
        }
        if (checkoutInfo && checkoutInfo.isCheckoutDay) { // 체크아웃하는날 체크아웃시간 이후 선택 불가
          isDisabled = disabled(checkoutInfo.checkoutTime, moment(x.from).format('HHmm'), true)
          isCheckoutOver = disabled(checkoutInfo.checkoutTime, moment(x.from).format('HHmm'), true)
        }
        return {
          ...x,
          disabled: isDisabled,
          checkoutOver: isCheckoutOver
        }
      })
    }
  },
  watch: {
    reserveTime (time) {
      if (!time) {
        this.time = ''
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      setInterval(() => {
        this.timeNow = moment().format('HHmm')
      }, 1000)
      if (this.timeInfo && this.timeInfo.length === 1) {
        this.time = this.timeInfo[0].timeId
        this.selectTime()
      }
    })
  },
  data () {
    return {
      time: '',
      timeNow: ''
    }
  },
  methods: {
    selectTime () {
      const time = this.time
      const timeHhmm = `${time.substr(0, 2)}:${time.substr(2, 2)} ~ ${time.substr(4, 2)}:${time.substr(6, 2)}`
      this.$emit('setTime', {
        id: time,
        name: timeHhmm
      })
    }
  }
}
</script>
